import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

/**
 * Get reports note sections
 *
 * @returns {Promise}
 */
export const getReportNoteSections = async () => {
  const { data } = await api.get(endpoints.reportNoteSections.get);

  return data;
};

/**
 * Create report note section
 * @param {Object} payload
 * @returns {Promise}
 */
export const createReportNoteSection = async (payload) => {
  const { data } = await api.post(endpoints.reportNoteSections.get, payload);

  return data;
};

/**
 * Update report note section
 * @param {string} id
 * @param {Object} payload
 * @returns {Promise}
 */
export const updateReportNoteSection = async (id, payload) => {
  const url = interpolate(endpoints.reportNoteSections.getById, { id });

  const { data } = await api.put(url, payload);

  return data;
};

/**
 * Delete report note section
 * @param {string} id
 * @returns {Promise}
 */
export const deleteReportNoteSection = async (id) => {
  const url = interpolate(endpoints.reportNoteSections.getById, { id });

  await api.delete(url);
};
